// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qr-reader {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  padding-bottom: 3em;
}

.qr-reader video {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  object-fit: cover;
  border: 1px solid rgb(203, 215, 231);
}

.qr-reader .qr-box {
  width: 100% !important;
  left: 0 !important;
}

.qr-reader .qr-frame {
  position: absolute;
  fill: none;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}

/* Media Queries for mobile screens */
@media (max-width: 426px) {
  .qr-reader {
    width: 100%;
  }
}
.camera_select {
  height: 3em;
  padding: 0.5em 0;
  outline: none;
  position: absolute;
  bottom: 0;
  left: 0;
}

.qr-reader-title {
  position: absolute;
  top: calc(80vh - 2.5em);
  right: 5px;
}

.scaner_container {
  height: 70vh;
  width: 100%;
  border-radius: 5px;
}

.sample_circule {
  height: 50px;
  width: 50px;
  background-color: rgba(146, 142, 142, 0.559);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sample_circule_container {
  width: 100%;
  height: 54px;
  margin: 10px 0;
  border-radius: 5px;
  border: 1px solid rgb(203, 215, 231);
  padding: 1px 2px;
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
}`, "",{"version":3,"sources":["webpack://./src/Components/QRReader/scaner.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;AACF;;AAEA,qCAAA;AACA;EACE;IACE,WAAA;EACF;AACF;AAEA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EAEA,OAAA;AADF;;AASA;EACE,kBAAA;EACA,uBAAA;EACA,UAAA;AANF;;AASA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AANF;;AASA;EACE,YAAA;EACA,WAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AANF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,QAAA;AALF","sourcesContent":[".qr-reader {\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  position: relative;\n  padding-bottom: 3em;\n}\n\n.qr-reader video {\n  width: 100%;\n  height: 100%;\n  border-radius: 5px;\n  object-fit: cover;\n  border: 1px solid rgba(203, 215, 231, 1);\n}\n\n.qr-reader .qr-box {\n  width: 100% !important;\n  left: 0 !important;\n}\n\n.qr-reader .qr-frame {\n  position: absolute;\n  fill: none;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n}\n\n/* Media Queries for mobile screens */\n@media (max-width: 426px) {\n  .qr-reader {\n    width: 100%;\n  }\n}\n\n.camera_select {\n  height: 3em;\n  padding: 0.5em 0;\n  outline: none;\n  position: absolute;\n  bottom: 0;\n  // width: 100%;\n  left: 0;\n}\n.camera_select_container {\n  // display: flex;\n  // justify-content: center;\n  // width: 100%;\n}\n\n.qr-reader-title {\n  position: absolute;\n  top: calc(80vh - 2.5em);\n  right: 5px;\n}\n\n.scaner_container {\n  height: 70vh;\n  width: 100%;\n  border-radius: 5px;\n}\n\n.sample_circule {\n  height: 50px;\n  width: 50px;\n  background-color: rgba(146, 142, 142, 0.559);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.sample_circule_container {\n  width: 100%;\n  height: 54px;\n  margin: 10px 0;\n  border-radius: 5px;\n  border: 1px solid rgba(203, 215, 231, 1);\n  padding: 1px 2px;\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
